import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { isEmpty, isEmail } from "../../validators/helper.js";
import { useNavigate } from "react-router";
import { MDBBtn, MDBModalFooter, MDBSpinner, MDBAlert } from "mdb-react-ui-kit";
import { getMisc, createUser } from "../../../apiclients/streamsapi_bridge.js";
import { useForm } from "react-hook-form";
import SeatLimitAlert from "../../../apiclients/SeatLimitAlert.jsx";
const AddUser = forwardRef(({ onClose, setHasPrevilege, setErrorMessage, groupInfo, locUser, setIsloading }, ref) => {

  const [autoext, setAutoext] = useState(true);
  const [extCheckFlag, setextCheckFlag] = useState(0);
  const [checkAvailbility, setCheckAvailbility] = useState(false);
  const [checkAvailbilityTxt, setCheckAvailbilityTxt] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const [selectedSuite, setSelectedSuite] = useState("--");
  const [selectedPrice, setSelectedPrice] = useState("0.0");
  const [allowExtension, setallowExtension] = useState(true);

  const [selectedTerm, setSelectedTerm] = useState(0);
  // const [isloading, setIsloading] = useState(false);

  const { t, i18n } = useTranslation();
  const [services, setServices] = useState([]);
  const [terms, setTerms] = useState([]);
  const [allLocations, setAllLocations] = useState([]);
  const [billingGroupList, setBillingGroupList] = useState([]);
  const [defaultLoc, setDefaultLoc] = useState({});
  const isWholesaleAcc = JSON.parse(sessionStorage.getItem("admin_session"))?.isWholesaleAcc ?? false;
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const [Warningalert, setWarningalert] = useState("");

  const { register, formState, getValues, handleSubmit, setError, clearErrors, reset, watch } = useForm({
    defaultValues: {
      fname: "",
      lname: "",
      emailid: "",
      extension: "",
      serviceid: 0,
      term: 0,
      loc_id: 0,
      billing_grp: 1,
    }
  });
  const { errors, isDirty } = formState
  const navigate = useNavigate();

  async function fetchData() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["services", "term", "all_locations", "billinggroups"], check_ext: 335 }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with ID not found`);
      navigate("/");
    }
    console.log(tdata);
    setServices(tdata.misc.services);
    setTerms(tdata.misc.term);
    const termList = tdata.misc.term ?? [];
    if (termList.length === 2) {
      const termid = termList[1].duration;
      reset({
        fname: "",
        lname: "",
        emailid: "",
        extension: "",
        serviceid: 0,
        term: parseInt(termid),
        loc_id: 0,
        billing_grp: 1,
      })
    }
    setAllLocations(tdata.misc.all_locations)
    setBillingGroupList(tdata.misc.billinggroups)
    const defaultLocation = tdata.misc.all_locations.find(loc => loc?.default_loc);
    if (defaultLocation) {
      setDefaultLoc({
        loc_id: locUser?.location_id ? parseInt(locUser.location_id) : defaultLocation?.loc_id,
      })
    }
  }
  useEffect(() => {
    if (defaultLoc && Object.keys(defaultLoc).length > 0) {
      reset(defaultLoc);
    }

  }, [defaultLoc])
  async function checkAvailability(e) {
    setextCheckFlag(1);
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { check_ext: parseInt(e.target.value) }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    if (tdata.check_ext) {
      setCheckAvailbility(true);
      setError("extension", { message: "Extension is available" });
    } else {
      setCheckAvailbility(false);
      setError("extension", { message: "Extension is not available" });
    }
    console.log(tdata);
  }
  const onsubmit = async (data) => {
    if (parseInt(data.serviceid) === 0) {
      setError("serviceid", { message: "Please select a seat plan" });
      return;

    }
    let updates = {};
    if (isDirty) {
      updates = {
        reqid: 2,
        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        fname: data.fname,
        lname: data.lname,
        emailid: data.emailid,

        serviceid: parseInt(data.serviceid),
        term: isWholesaleAcc ? 0 : parseInt(data.term),
        autoassign: false,
        logined_user: JSON.parse(sessionStorage.getItem("admin_session")).logined_user,
        loc_id: parseInt(data?.loc_id),
        billing_grp: parseInt(data?.billing_grp)
      };
      if (groupInfo) {
        updates.add_to_group = {};
        updates.add_to_group.entity_id = parseInt(groupInfo.entity_id);
        updates.add_to_group.group_type = parseInt(groupInfo.type);
      }
      if (allowExtension && data.extension) {
        updates.extension = data?.extension ? parseInt(data.extension) : "";
      }
    }
    setCheckAvailbility(false);
    //alert(JSON.stringify(updates))
    console.log("JSON Create USER:: " + JSON.stringify(updates));
    setIsloading(true);
    let saverep = await createUser(updates);
    console.log(`reponse of add user :::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log(`reponse of add user after:::: ${JSON.stringify(saverepeMsg)}`);
    // setTimeout(() => {
      setIsloading(false);
    // }, 2000);
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      localStorage.setItem("s_message", "User created successfully.");
      onClose();
      if (locUser) {
        navigate("/locationsusers", {
          state: { tab: locUser },
        });

      } else if (groupInfo) {
        navigate("/usersgroups", {
          state: { tab: groupInfo },
        });

      } else {
        navigate("/userlanding", {
          state: { tab: "suser", tab2: "suser" },
        });
      }


      window.location.reload();
    } else {
      setCheckAvailbility(false);
      if (saverepeMsg.message?.errors) {
        if (
          saverepeMsg.message?.errors[0].errors &&
          saverepeMsg.message?.errors[0].errors.length > 0
        ) {
          let addonerr = [];
          saverepeMsg.message.errors[0].errors.forEach((err) => {
            if (!err.param_name) {
              addonerr.push(err);
            } else {
              if (err.param_name === "logined_user") {
                setErrorMessage(err.message);
                setHasPrevilege(true)
                onClose();
              }
              setError(err.param_name, {
                type: "server",
                message: err.message,
              });
            }
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
              fieldElement.scrollIntoView({ behavior: "smooth" });
            }
          });
        }
      } else {
        if (saverepeMsg.seat_limit_exceed && saverepeMsg.seat_limit_exceed !== "") {
          setWarningalert(saverepeMsg.seat_limit_exceed);
          setShowWarning(true);



        } else {
          localStorage.setItem("f_message", saverepeMsg.message);
          onClose();
          if (locUser) {
            navigate("/locationsusers", {
              state: { tab: locUser },
            });

          } else if (groupInfo) {
            navigate("/usersgroups", {
              state: { tab: groupInfo },
            });

          } else {
            navigate("/userlanding", {
              state: { tab: "suser", tab2: "suser" },
            });
          }

          window.location.reload();
        }
      }

    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  const serviceValidation = (value) => {
    if (value === 0) {
      return 'Please Select the Service Plan';
    }
    return true;
  };
  function changeService(e) {
    try {
      clearErrors("serviceid");
      // console.log(JSON.stringify(services));
      setSelectedSuite(services.filter((item) => parseInt(item.id) === parseInt(e.target.value))[0].name);
      setSelectedPrice(
        services.filter((item) => parseInt(item.id) === parseInt(e.target.value))[0].price
      );
      setallowExtension(
        services.filter((item) => parseInt(item.id) === parseInt(e.target.value))[0]?.sid === "SMARTBOXENT" ? false : true
      );
    } catch (ex) {
      setSelectedSuite("--");
      setSelectedPrice("0.0");
      //alert(e);
    }
  }

  const handleOk = () => {
    reset();
    warningToggle();
    onClose();
  }
  return (
    <>
      {/* {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )} */}
      <form>
        <div className="row">
          <div className="col-6">
            <div className="tel-numbers">
              <strong>{t("firstName")}</strong>
            </div>
            <div className="form pt-1 w-100">
              <input
                type="text"
                maxLength={30}
                className="form-control w-100"
                {...register("fname", { required: "First Name is required" })}
                tabIndex="13"
              />
              {errors.fname && (
                <p className="text-danger">{errors.fname.message}</p>
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="tel-numbers">
              <strong>{t("lastName")}</strong>
            </div>
            <div className="form pt-1">
              <input
                type="text"
                maxLength={20}
                className="w-100"
                {...register("lname", { required: "Last Name is required" })}
              />
              {errors.lname && (
                <p className="text-danger">{errors.lname.message}</p>
              )}
            </div>
          </div>
          <div className="tel-numbers mt-2">
            <strong>{t("email_address")}</strong>
          </div>
          <div className="form pt-1">
            <input
              type="text"
              className="w-100"
              {...register("emailid", {
                setValueAs: (v) => v?.trim(), 
                required: "Email Address is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid Email Address",
                },
              })}
            />
            {errors.emailid && (
              <p className="text-danger">{errors.emailid.message}</p>
            )}
          </div>
          <div className="col-6 pt-2">
            <div className="tel-numbers">
              <strong>{t("SeatPlan")}</strong>
            </div>
            <div className="form pt-1">
              <div>
                <select
                  className="form-select form-control w-100"
                  name="San Jose"
                  {...register("serviceid", {
                    required: "Please select a seat plan",
                    validate: serviceValidation
                  })}
                  onChange={(e) => changeService(e)}

                >
                  <option value={""} >
                    Select Seat Plan
                  </option>
                  {services &&
                    services.map((item) => (
                      <>
                        <option value={item.id}>{item.name}</option>
                      </>
                    ))}
                </select>
                {errors.serviceid && (
                  <p className="text-danger">{errors.serviceid.message}</p>
                )}
              </div>
            </div>
          </div>
          {
            !isWholesaleAcc && 
          <div className="col-6 pt-2">
            <div className="tel-numbers">
              <strong>{t("SeatTerm")}</strong>
            </div>
            <div className="form pt-1">
              <div>
                <select
                  className="form-select form-control w-100"
                  name="San Jose"
                  {...register("term")}
                >
                  {terms &&
                    terms.map((item) => (
                      <>
                        <option value={item.duration}>{item.type}</option>
                      </>
                    ))}
                </select>
              </div>
            </div>
          </div>

          }
          {allowExtension && (
            <div className="col-6 pt-2">
              <div className="tel-numbers">
                <strong>{t("extension")}</strong>
              </div>
              <input
                type="text"
                maxLength={5}
                className=" form-control w-100 me-3"
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                {...register("extension", {
                  required: "Extension is required",
                  minLength: {
                    value: 3,
                    message: 'Extension must be at least 3 characters',
                  },
                  maxLength: {
                    value: 5,
                    message: 'Extension must not exceed 5 characters',
                  },
                })}
                onChange={(e) => {
                  e.preventDefault();
                  if (!/^\d+$/.test(e.target.value)) {
                    setCheckAvailbility(false);
                    setError("extension", { message: "Extension is required and must be numeric" });
                  } else if (+e.target.value > 9989 && +e.target.value <= 9999) {
                    setCheckAvailbility(false);
                    setError("extension", {
                      message: "Select an extension in the range of 100 to 9989 or 10000 to 99999."
                    });
                  }
                  else if (e.target.value.length >= 3 && e.target.value.length <= 5) {
                    if (e.target.value.charAt(0) === "0") {
                      setCheckAvailbility(false);
                      setError("extension", { message: "An extension cannot begin with zero(0)" });
                    } else {
                      checkAvailability(e);
                    }
                  } else {
                    setCheckAvailbility(false);
                    clearErrors("extension");
                  }
                }}
              />
              {errors.extension && (
                <>
                  {!checkAvailbility && (
                    <>
                      <p className="text-danger">
                        {errors.extension.message}
                      </p>
                    </>
                  )}

                  {checkAvailbility && (
                    <p style={{ color: "Green" }} className="clr-red">
                      {errors.extension.message}
                    </p>
                  )}
                </>
              )}

            </div>
          )}
          <div className="col-6 pt-2 ">
            <div className="tel-numbers">
              <strong>{t("location")}</strong>
            </div>
            <select
              className="form-select form-control w-100"
              name="San Jose"
              disabled={locUser != undefined ? true : false}
              {...register("loc_id", {
                setValueAs: (value) => Number(value)
              })}

            >
              {allLocations && allLocations.map((loc) => (
                <option value={loc.loc_id}>{loc.loc_name}</option>
              ))}
            </select>
            {errors?.loc_id && (
              <p className="text-danger">{errors.loc_id.message}</p>
            )}
          </div>
          <div className="col-6 pt-2">
            <div className="tel-numbers">
              <strong>{t("billingGroup")}</strong>
            </div>
            <select className="form-select form-control w-100"
              name="San Jose"
              {...register("billing_grp", {
                required: "Please select billing group"
              })}
            >
              {billingGroupList && billingGroupList.map((bgrp) => (
                <option value={bgrp.groupid}>{bgrp.groupname}</option>
              ))}
            </select>
            {errors.billing_grp && (
              <p className="text-danger">{errors.billing_grp.message}</p>
            )}
          </div>
          <div style={{ height: 60 }}>
            {selectedSuite !== "--" && (<>
              <p className="text-secondary pt-2 mt-2">
                A <span className="green-text"> {selectedSuite}</span>
                &nbsp;{t("CallCenterseattxt")}.
              </p>
              <p className="text-secondary lh-sm mb-3">
                {t("AddOnenabletxt")}
                <span className="green-text"> ${selectedPrice}</span>.
              </p>
            </>)}
          </div>

          <div style={{ display: "none" }}>
            <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(onsubmit)() }}>
              {t("add")}</button>
          </div>
        </div>{" "}
      </form>

      {showWarning && (
        <SeatLimitAlert
          warningToggle={warningToggle}
          setShowWarning={setShowWarning}
          warningMessage={Warningalert}
          onOk={handleOk}
        />
      )}
    </>
  );
});

export default AddUser;
